import { Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import theme from "./styles/theme";
import GlobalStyles from "./styles/GlobalStyles";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppFloat from "./components/WhatsAppFloat";

import Home from "./routes/Home";
import Products from "./routes/Products";
import ProductPage from "./routes/ProductPage";
import About from "./routes/About";
import Faq from "./routes/Faq";
import Contact from "./routes/Contact";
import NotFound from "./routes/NotFound";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/produktet" element={<Products />} />
          <Route path="/produktet/:slug" element={<ProductPage />} />
          <Route path="/rreth-nesh" element={<About />} />
          <Route path="/pyetje" element={<Faq />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFloat />
    </ThemeProvider>
  );
}
